import { org_sector_type_enum } from '@predium/enums';
import { I18nKeys, PreTFunctionArgs, ProcessedTranslations } from '@predium/i18n/client';
// eslint-disable-next-line no-restricted-imports
import { Trans as OriginalTrans, TransProps as OriginalTransProps } from 'react-i18next';
import { HasRequiredKeys } from 'type-fest';

type TransProps<Key extends I18nKeys> = Omit<OriginalTransProps<Key>, 'i18nKey' | 'values'> & {
  i18nKey: Key;
} & (HasRequiredKeys<ProcessedTranslations[Key]> extends true
    ? {
        values: PreTFunctionArgs<Key>[1];
      }
    : {
        values?: {};
      });

export const Trans = <Key extends I18nKeys>(props: TransProps<Key>) => {
  const { i18nKey, ...rest } = props;
  const options = rest.values;
  const orgSector = ((options ?? {}) as { orgSector?: org_sector_type_enum })?.orgSector;

  let key = i18nKey;
  if (orgSector) {
    key = `${key}_${orgSector}` as Key;
  }

  return <OriginalTrans i18nKey={key} {...rest} />;
};
